export default __webpack_public_path__ + "static/media/pvilla6-3.0fb7fae1.webp";